<script setup lang="ts">
import type { CommandItemBaseProps } from "./types";
import { Italic } from "ls/common/keyboardShortcuts";
import { ItalicIcon } from "lucide-vue-next";
import SuggestionListItem from "../suggestions/SuggestionListItem.vue";

const props = defineProps<CommandItemBaseProps>();

function run() {
  props.editor
    .chain()
    .focus()
    .deleteRange(props.range)
    .setItalic()
    .run();
}

defineExpose({ run });
</script>

<template>
  <SuggestionListItem
    :shortcut="Italic"
    :icon="ItalicIcon"
    @click="run"
    @keydown.enter="run"
  >
    Italics
  </SuggestionListItem>
</template>
